"use client";

import { c as _c } from "react/compiler-runtime";
import { useHasMounted } from "@/hooks/useHasMounted";
import { useCookieConsent } from "@/lib/cookies/useCookieConsent";
import { clsx } from "clsx";
import { Cookie } from "lucide-react";
import { useState } from "react";
import { CookiePreferences } from "./CookiePreferences";
import type { CookieDictionary } from "./types";
interface CookieSettingsButtonProps {
  dictionary: CookieDictionary;
  className?: string;
}

/**
 * Bouton pour rouvrir les préférences de cookies
 * À utiliser dans le footer
 */
export function CookieSettingsButton(t0) {
  const $ = _c(15);
  const {
    dictionary,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const {
    hasInteracted
  } = useCookieConsent();
  const [showPreferences, setShowPreferences] = useState(false);
  const hasMounted = useHasMounted();
  if (!hasMounted || !hasInteracted) {
    return null;
  }
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setShowPreferences(true);
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== className) {
    t3 = clsx("inline-flex items-center gap-2 text-sm text-wood-natural transition-colors hover:text-forest-green", className);
    $[1] = className;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Cookie className="h-4 w-4" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = dictionary.managePreferences || "G\xE9rer les cookies";
  let t6;
  if ($[4] !== t5) {
    t6 = <span>{t5}</span>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t3 || $[7] !== t6) {
    t7 = <button onClick={t2} className={t3} aria-label={"G\xE9rer les pr\xE9f\xE9rences de cookies"}>{t4}{t6}</button>;
    $[6] = t3;
    $[7] = t6;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== dictionary || $[10] !== showPreferences) {
    t8 = showPreferences && <CookiePreferences dictionary={dictionary} onClose={() => setShowPreferences(false)} />;
    $[9] = dictionary;
    $[10] = showPreferences;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t7 || $[13] !== t8) {
    t9 = <>{t7}{t8}</>;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}